export default function () {
    function cycletestimonial() {
        var clientTestimonialLength = $('footer .client-testimonial').length;
        var x = 1;
        $('footer .client-testimonial').each(function(){
            if( $(this).hasClass('current') ) {
                $(this).removeClass('current');
                $(this).fadeOut(500);

                if(x < clientTestimonialLength) {
                    $(this).next().addClass('current');
                    return false;
                } else {
                    $('footer .client-testimonial').first().addClass('current');
                    return false;
                }
            }
            x++;
        });

        setTimeout(function(){
            $('footer .client-testimonial.current').fadeIn(500);
        }, 625);

        setTimeout(function(){
            cycletestimonial();
        }, 5000);
    }

    $('header form a').on('click', function(){
        $('header form').removeClass('inactive');
        $(this).parents('form').addClass('inactive').hide();
        $('header form').each(function(){
            if(!$(this).hasClass('inactive')) {
                $(this).show();
            }
        });
    });

    $('.faq-sidebar .faq-question').on('click', function(){
        $(this).next().slideToggle();
    });

    $('footer .client-testimonial').first().addClass('current').fadeIn(500);
    setTimeout(cycletestimonial, 5000);

    $('.help-icon').on('click', function(){
        $(this).next().slideToggle();
    });

    $('.hide-help').on('click', function(){
        $(this).parents('.help-box').slideToggle();
    });
}
